import { groupBy, uniq } from 'lodash-es';
import { createErrorObject } from "../../components/ImportWizard/ImportWizard.utils";
import { bundleColumnsToValidate, errorMessages } from "./servicesValidation.utils";
export function extractBundles(data) {
  return data.reduce((acc, row) => {
    if (row.bundleName) {
      acc.bundleRows.push(row);
    } else {
      acc.nonBundleRows.push(row);
    }
    return acc;
  }, {
    bundleRows: [],
    nonBundleRows: []
  });
}
export function validateBundleServicesSize(bundleServices) {
  const errors = [];
  Object.entries(bundleServices).forEach(_ref => {
    let [bundleName, {
      services,
      lineNumber
    }] = _ref;
    if (services.size < 2) {
      errors.push(createErrorObject('bundle name', lineNumber, errorMessages.getBundleMustHave2ServicesError(bundleName)));
    }
  });
  return errors;
}
export function validateBundleColumnsConsistency(bundlesColumnDataToValidate) {
  const errors = [];
  const bundles = groupBy(bundlesColumnDataToValidate, row => row.bundleName);
  Object.values(bundles).forEach(bundleRows => {
    if (bundleRows.length > 1) {
      const inconsistentColumns = [];
      bundleColumnsToValidate.forEach(column => {
        const values = bundleRows.map(row => row[column]);
        const uniqueValues = uniq(values);
        if (uniqueValues.length > 1) {
          inconsistentColumns.push(column);
        }
      });
      if (inconsistentColumns.length > 0) {
        errors.push(createErrorObject('bundle name', bundleRows[0].lineNumber, errorMessages.getBundleColumnsConsistencyError(bundleRows[0].bundleName, inconsistentColumns)));
      }
    }
  });
  return errors;
}